import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { JobSkillMutator } from '@/lib/entity/job_skill'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type JobSkillSchema = JobSkillMutator['merged']

export const JobSkillConverter: Converter<JobSkillSchema> = {
  icon: () => i18next.t('stages.icon.job_skill'),
  title: () => i18next.t('stages.table.job_skill'),
  subTitle: async (merged) => merged.name ?? i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.job_skill.${column}`)
    return match(column)
      .with('name', 'choosable', (column) => asModifiedField(label, modified[column]!))
      .with('id', 'order', () => undefined)
      .exhaustive()
  }
}
